import { auth } from '@/lib/auth'
import { useTheme } from '@/lib/useTheme'
import { Outlet, createRootRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'

export const Route = createRootRoute({
  component: () => {
    // 라우트 기반 테마 자동 스위칭 (Dashboard vs Public)
    useTheme()

    // OAuth 콜백에서 토큰 추출 및 저장
    useEffect(() => {
      const token = auth.extractTokenFromUrl()
      if (token) {
        auth.setToken(token)
        window.history.replaceState({}, document.title, '/')
        window.location.href = '/'
      }
    }, [])

    return (
      <>
        <Outlet />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: 'rgb(var(--color-surface-container-lowest))',
              color: 'rgb(var(--color-on-surface))',
              border: '1px solid rgb(var(--color-surface-container-high))',
              borderRadius: '0.75rem',
              fontSize: '0.875rem',
            },
            success: {
              iconTheme: {
                primary: '#16a34a',
                secondary: 'white',
              },
            },
            error: {
              iconTheme: {
                primary: 'rgb(var(--color-error))',
                secondary: 'white',
              },
            },
          }}
        />
      </>
    )
  },
})
